import { render, staticRenderFns } from "./usermenu.vue?vue&type=template&id=28e8c090"
import script from "./usermenu.vue?vue&type=script&lang=js"
export * from "./usermenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports